import Vue from 'vue'
import Router from 'vue-router'

import AccountAPI from '@/api/account.js'
import { Account, ShoppingCart } from '@/functions.js'

import Home from '@/components/page/Home'
import About from '@/components/page/About'
import CartPage from '@/components/page/Cart'
import Checkout from '@/components/page/Checkout'
import OrderConfirmation from '@/components/page/OrderConfirmation'
import AccountPage from '@/components/page/Account'
import ComingSoon from '@/components/page/ComingSoon'
import PrivacyStatement from '@/components/page/PrivacyStatement'

import Contact from '@/components/page/Contact'
import FAQ from '@/components/page/FAQ'
import Login from '@/components/page/Login'
import Logout from '@/components/page/Logout'
import ForgotPassword from '@/components/page/ForgotPassword'
import PasswordReset from '@/components/page/PasswordReset'
import Mail from '@/components/page/Mail'
import OrderTracking from '@/components/page/OrderTracking'
import PageNotFound from '@/components/page/PageNotFound'

import ProductDetails from '@/components/page/ProductDetails'
import Register from '@/components/page/Register'
import Shop from '@/components/page/Shop'

Vue.use(Router)

async function isAuthorized(to, from, next) {
	var session_account = JSON.parse(sessionStorage.getItem('gsm_at'));
	if(session_account)
	{
		if (session_account.login_id == '' || session_account.token == '')
		{
			return next('/login');
		}
		else
		{
			const access = await AccountAPI.ping(session_account.login_id, session_account.token);
			// console.log(access);
			if (access.status == 'failed')
			{
				Account.setLoginId('');
				Account.setToken('');
				return next('/login?m=session_expired');
			}
			else
			{
				Account.setLoginId(session_account.login_id);
				Account.setToken(session_account.token);
				return next();
			}

		}
	}
	else
	{
		return next('/login');
	}
};

async function isNotLoggedIn(to, from, next) {
	var session_account = JSON.parse(sessionStorage.getItem('gsm_at'));

	if(session_account)
	{
		if (session_account.login_id == '' || session_account.token == '')
		{
			Account.setLoginId('');
			Account.setToken('');
			return next();
		}
		else
		{
			Account.setLoginId(session_account.login_id);
			Account.setToken(session_account.token);
			return next('/account');
		}
	}
	else
	{
		return next();
	}
	
};

async function isSuccessfulCheckout(to, from, next) {
	var session_order = JSON.parse(sessionStorage.getItem('order_success'));
	console.log(session_order);
	if(session_order)
	{
		return next();
	}
	else
	{
		return next('/');
	}
	
};


function allowToCheckout(to, from, next) {
  var session_account = JSON.parse(sessionStorage.getItem('gsm_at'));

  if (ShoppingCart.getTotalCartItems() <= 0)
  {
  	return next('/cart');
  }
  else if(!session_account)
  {
  	return next('/login?m=unauthorized&redirect=checkout');
  }
  else if(session_account && (session_account.customer_id == ""))
  {
  	return next('/login?m=unauthorized&redirect=checkout');
  }
  else
  {
  	return next();
  }
};

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
  	if(to.name != from.name)
    	return { x: 0, y: 0, behavior: 'smooth' };
    else
    	return {};
  },
  routes: [
    {
		  path: '/',
		  name: 'home',
		  component: Home
    },
    {
		  path: '/home',
		  redirect: '/'
    },
    {
		  path: '/about',
		  name: 'about',
		  component: About
    },
    {
		  path: '/cart',
		  name: 'cart',
		  component: CartPage
    },
    {
		  path: '/comming-soon',
		  name: 'comingSoon',
		  component: ComingSoon
    },
    {
		  path: '/contact-us',
		  name: 'contact',
		  component: Contact
    },
    {
	    path: '/contact',
	    redirect: to => {
	      return { path: '/contact-us' }
	    },
	},
    {
		  path: '/faq',
		  name: 'faq',
		  component: FAQ
    },
    {
		  path: '/forgot-password',
		  name: 'forgotPassword',
		  component: ForgotPassword
    },
    {
		  path: '/account/password-reset/auth/:resethash',
		  redirect: to => {
		      // the function receives the target route as the argument
		      // we return a redirect path/location here.
		      return { path: '/password-reset/:resethash', params: { resethash: to.params.resethash } }
		    },
    },
    {
		  path: '/password-reset/:resethash',
		  name: 'passwordReset',
		  component: PasswordReset
    },
    {
		  path: '/mail',
		  name: 'mail',
		  component: Mail
    },
    {
		  path: '/order-tracking',
		  name: 'orderTracking',
		  component: OrderTracking,
    },
    {
		  path: '/shop/product/:sku_id/:sku_name',
		  name: 'productDetails',
		  component: ProductDetails
    },
    {
		  path: '/login',
		  name: 'login',
		  component: Login,
		  beforeEnter: isNotLoggedIn
    },
    {
		  path: '/logout',
		  name: 'logout',
		  component: Logout
    },
    {
		  path: '/account/:tab?',
		  name: 'account',
		  component: AccountPage,
		  beforeEnter: isAuthorized
    },
    {
		  path: '/register',
		  name: 'register',
		  component: Register
    },
    {
		  path: '/shop',
		  name: 'shop',
		  component: Shop
    },
    {
		  path: '/privacy-statement',
		  name: 'privacyStatement',
		  component: PrivacyStatement
    },
    {
		  path: '/checkout',
		  name: 'checkout',
		  component: Checkout,
		  beforeEnter: allowToCheckout
    },
    {
		  path: '/checkout/order/success',
		  name: 'orderConfirmation',
		  component: OrderConfirmation,
		  beforeEnter: isSuccessfulCheckout
    },
    {
		  path: '*',
		  name: 'pageNotFound',
		  component: PageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js